import Newsletter_50_container from "./container/Newsletter_50_container";
export default Newsletter_50_container;
